import { useState, useEffect } from "react";
import { ALLOW_CHAR_NUM,ALLOW_ALPHABET} from '@src/config/constant';
// interface InputFieldProps {
//     inputProps: FieldProps,
//     onChange: any
// }
// interface FieldProps {
//     id: string,
//     type: string,
//     name: string,
//     maxLength: any,
//     value: any,
//     className: string,
//     disabled: boolean,
//     placeholder?: string|null|undefined,
// }

const InputField = (props: any) => {


    const [inputProps, setInputProps] = useState<any>({
        id: props.inputProps.id || '',
        type: props.inputProps.type || '',
        name: props.inputProps.name || '',
        maxLength: props.inputProps.maxLength || '',
        value: props.inputProps.value || "",
        className: props.inputProps.className || 'form-control',
        disabled: props.inputProps.disabled || false,
        placeholder: props.inputProps.placeholder || "",
        spellCheck:props.spellCheck || true
    });

    useEffect(() => {
        setInputProps({ ...inputProps, ...props.inputProps })
        // eslint-disable-next-line
    }, [props.inputProps]);

    const changeHandel = (event: any) => {
        if (typeof props.onChange === 'function') {
            if (props.validation && ['per_postal_code','cur_postal_code']?.includes(event?.target?.name)) {
                const value = event.target.value
                const { maxLength } = props.validation;
                
                if (!/^\d*$/.test(value)) {
                    return;
                }
                if (maxLength && value.length > maxLength) {
                    return;
                }
            }

            let pattern = /^\d+$/;
            let isValid = true;
            let updatedValue: any = ''
            let percentagePattern = /^[0-9]+(\.[0-9]{0,2})?$/;

            if (props.inputProps.id === 'mobile' || props.inputProps.id === 'alternate_mobile' || props.inputProps.id === 'tin_id_no' || props.inputProps.id === 'rt' || props.inputProps.id === 'rw') {
                if (event.target.value && !pattern.test(event.target.value)) {
                    updatedValue = inputProps?.value
                    // return false;
                    isValid = false;
                } else if (props.inputProps.maxLength && event.target.value.length > props.inputProps.maxLength) {
                    // return false;
                    updatedValue = inputProps?.value

                    isValid = false;

                } else {
                    updatedValue = event.target.value

                }
            } else if (props.inputProps.id === "percentage") {
                if (event.target.value && !percentagePattern.test(event.target.value)) {

                    // return false;
                    updatedValue = inputProps?.value

                    isValid = false;

                } else if (props.inputProps.maxLength && +event.target.value > +props.inputProps.maxLength) {
                    // return false;
                    updatedValue = inputProps?.value

                    isValid = false;

                } else {
                    updatedValue = event?.target?.value

                }
            } 
            // allow alphanumeric for referrer name
            else if (props.inputProps.id === "referrer_name" && event?.target?.value) {
                if (!ALLOW_ALPHABET.test(event.target.value)) {
                    updatedValue = inputProps?.value;
                    isValid = false;
                } else {
                    updatedValue = event.target.value;
                }
            }
            // allow number character for employee no
            else if (props.inputProps.id === "employee_no" && event?.target?.value) {
                if (!ALLOW_CHAR_NUM.test(event.target.value)) {
                    updatedValue = inputProps?.value;
                    isValid = false;
                } else {
                    updatedValue = event.target.value;
                }
            }
            else{
                updatedValue = event.target.value

            }
            //  else if (props.inputProps.id === "customer_name") {
            //     if (event.target && event.target.value && !event.target?.value?.trim()) {
            //         return false;
            //     }
            // }
            if (isValid) {
                props.onChange(event);
            }

            setInputProps({ ...inputProps, value: updatedValue });
        }
    }

    const chkValFocusOut = (event: any) => {
        setInputProps({ ...inputProps, value: event.target.value });
        if (props.onBlur) {
            props?.onBlur(event)
        }

    }
    const chkValFocus = (event: any) => {
        if (event.target.value) {
            setInputProps({ value: event.target.value })
            props.onChange(event)
        }
    }
    const blockInvalidKeys = (e: any) => {
        if (inputProps.type === "number") {
            if (["+", "-", "e", "E"].includes(e.key)) {
                e.preventDefault();
            }
        }
    };

    return (
        <>
            <input {...inputProps}
                onKeyDown={blockInvalidKeys}
                onBlur={chkValFocusOut}
                onFocus={chkValFocus}
                onChange={changeHandel} className={props.inputProps.className} autoComplete="off" />
        </>
    );
};

export default InputField;